<div class="product-list-container">

  @switch (deviceView) {
  @case ('desktop') { <app-product-list-fitlers-desktop [products]="products"
    (filtersOnChange)="applyFitlers($event)"></app-product-list-fitlers-desktop> }
  @case ('mobile') { <app-product-list-fitlers-mobile [products]="products"
    (filtersOnChange)="applyFitlers($event)"></app-product-list-fitlers-mobile> }
  }

  <div class="pre-table">
    <div class="search-result-txt">
      Risultato della ricerca
    </div>
  </div>

  <div class="table-container">

    <table mat-table [dataSource]="dataSource" matSort>

      <!-- Sticky empty placeholder -->
      <ng-container matColumnDef="stickyEmptyPlaceholder" sticky>
        <th mat-header-cell class="bg-light-blue column-name" *matHeaderCellDef></th>
      </ng-container>

      <!-- Empty placeholder Column -->
      <ng-container matColumnDef="emptyPlaceholder">
        <th mat-header-cell class="bg-light-blue" *matHeaderCellDef></th>
      </ng-container>

      <ng-container matColumnDef="emptyPlaceholderRed">
        <th mat-header-cell class="bg-light-red" *matHeaderCellDef></th>
      </ng-container>


      <!-- Minima racc. Group Header Column -->
      <ng-container matColumnDef="minRacc">
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="RendAttesiView == 'espandi' ? '3' : '2'"
          class="text-center bg-light-red"> <span class="tbl-group-header-col"
            (click)="openTblGroupHeaderDesc(groupHeader.minRacc)"><i class="fa-solid fa-circle-info pe-1"></i>
            {{deviceView == 'mobile' ? 'Durata racc.' : 'Durata
            raccom.'}}</span> </th>
      </ng-container>

      <ng-container matColumnDef="rendimentoAnnuoAtteso">
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="4" class="text-center bg-light-pink"> <span
            class="tbl-group-header-col" (click)="openTblGroupHeaderDesc(groupHeader.rendimentoAnnuoAtteso)"><i
              class="fa-solid fa-circle-info pe-1"></i> Rendimento annuo atteso al netto costi</span> </th>
      </ng-container>





      <!-- Name Column -->
      <ng-container matColumnDef="Name" sticky>
        <th class="comparatoreMF-box-shadow column-name bg-light-blue" mat-header-cell mat-sort-header
          *matHeaderCellDef> Nome polizza </th>
        <td class="column-name" mat-cell *matCellDef="let element">
          <!-- <a (click)="goToProductPage(element)">{{element.Name != null ? element.Name : '-'}}</a> -->
          <a routerLink="/policy/{{element.FidaCode}}" target="_blank">{{element.Name != null ? element.Name : '-'}}</a>
        </td>
      </ng-container>

      <!-- Company Column -->
      <ng-container matColumnDef="SocietyName">
        <th class="comparatoreMF-box-shadow text-center bg-light-blue" mat-header-cell mat-sort-header
          *matHeaderCellDef>

          Compagnia emittente


        </th>
        <td mat-cell class="text-center" *matCellDef="let element">


          <div class="company-logo-container">
            <img alt="logo {{element.Name}}" [src]="getCompanyLogoUrl(element)" class="company-logo-img " />

          </div>

        </td>
      </ng-container>

      <!-- CARATT. GEN. Columns -->

      <!-- Ramo vita Column -->
      <ng-container matColumnDef="Class">
        <th mat-header-cell class="text-center bg-light-blue" mat-sort-header *matHeaderCellDef> Ramo Vita </th>
        <td mat-cell class="text-center" *matCellDef="let element"> {{element.Class != null ?
          (element.Class.toLowerCase() == 'multiramo' ? 'Multi- \n ramo' : element.Class) : '-'}} </td>
      </ng-container>



      <!-- Premio min Column -->
      <ng-container matColumnDef="MinSinglePremium">
        <th mat-header-cell mat-sort-header class="text-center min-single-premium-col bg-light-blue" *matHeaderCellDef>
          Premio min. (€) </th>
        <td mat-cell class="text-center min-single-premium-col" [ngClass]="{'is-RecurPremium': element.RecurPremium}"
          *matCellDef="let element">
          @if(element.MinSinglePremium != null && element.MinSinglePremium > 0){
          {{element.MinSinglePremium | number}}

          }
          @else{
          @if(element.RecurPremium != null && element.RecurPremium != ""){


          <a [cPopover]="popoverHtml" class="mytooltip popover text-center" cPopoverPlacement="left" [cPopoverTrigger]="'hover'"
            cButton class="m-1" color="danger" size="lg">
            premio ricorrente
            <ng-template #popoverHtml>
              <div class="popover-body popover-my ">
                {{element.RecurPremium}}
              </div>
            </ng-template>
          </a>

          }
          @else{-}
          }
        </td>
      </ng-container>


      <!-- Riscatto anticip. Column -->
      <ng-container matColumnDef="IsPartialRefund">
        <th mat-header-cell mat-sort-header class="text-center bg-light-blue" *matHeaderCellDef> Riscatto anticip. </th>
        <td mat-cell class="text-center" *matCellDef="let element">
          @if (element.RefundMin != null) {
          <i class="fa-solid {{element.RefundMin > -1 ? 'fa-check check-icon' : 'fa-xmark xmark-icon'}}"></i>
          }
          @else { - }
        </td>
      </ng-container>


      <!-- COPERT. ASS. Columns -->

      <!-- Durata Column -->
      <ng-container matColumnDef="Duration">
        <th mat-header-cell mat-sort-header class="text-end bg-light-blue" *matHeaderCellDef>
          <div class="row">
            <div class="col-5">
            </div>
            <div class="col-7">
              <div class="col-12  "><span class="text-end">Durata </span> </div>
              <div class="col-12 "><span class="text-end ">polizza</span></div>
            </div>

          </div>
        </th>
        <td mat-cell class="text-center" *matCellDef="let element"> {{element.Duration ?? '-'}} </td>
      </ng-container>

      <!-- Nr. anni Column -->
      <ng-container matColumnDef="SuggestedPeriod">
        <th mat-header-cell mat-sort-header class="text-center bg-light-red suggested-period-col" *matHeaderCellDef> Nr.
          anni </th>
        <td mat-cell class="text-center bg-light-red suggested-period-col" *matCellDef="let element">
          {{(element.SuggestedPeriod != null && element.SuggestedPeriod != '') ? element.SuggestedPeriod : '-'}} </td>
      </ng-container>

      <!-- Costo annuo Column -->
      <ng-container matColumnDef="AnnualCost">
        <th mat-header-cell class="text-center bg-light-red annual-cost-col" *matHeaderCellDef> Costo annuo </th>
        <td mat-cell class="text-center bg-light-red annual-cost-col" *matCellDef="let element">
          @if (element.AnnualCost != null && element.AnnualCost != '') {
          <img [src]="element.AnnualCost" [height]="17" alt="Valore costo annuo" />
          }
          @else { <span>-</span> }
        </td>
      </ng-container>


      <!-- rend atteasi Column -->
      <ng-container matColumnDef="rendattesi">
        <th mat-header-cell class="text-center bg-light-red scenario-moderato-col " *matHeaderCellDef>
          <div class="d-flex justify-content-between align-items-center">
            <div class="">
              <span class=""> rend. attesi </span>
            </div>

            <div class="m-2">
              <span class="pl-2"><i (click)="clickrendAttesi()"
                  [ngClass]="RendAttesiView == 'espandi' ? 'fa-caret-right' : 'fa-caret-left'"
                  class="fa-solid  fa-2x pointer"></i></span>
            </div>
          </div>



        </th>

        <td mat-cell class="text-center bg-light-red scenario-moderato-col" *matCellDef="let element">
          @if(RendAttesiView == 'espandi' ){
          @if (element.ModerateScenario != null && element.ModerateScenario != '') {
          <img [src]="element.ModerateScenario" [height]="17" alt="Valore scenario moderato" />
          }
          @else { <span>-</span> }
          }
          @else{

          }


        </td>
      </ng-container>

      <!-- Scenario Moderato Column -->
      <ng-container matColumnDef="ScenarioModerato">

        <th mat-header-cell class="text-center bg-light-pink scenario-moderato-col" *matHeaderCellDef>
          <div class="d-flex justify-content-between align-items-center">
            <div class="">
              <span class="p-2"><i (click)="clickrendAttesi()"
                  [ngClass]="RendAttesiView == 'espandi' ? 'fa-caret-right' : 'fa-caret-left'"
                  class="fa-solid  fa-2x pointer"></i></span>
            </div>
            <div class="">
              <span class="">Scenario moderato</span>
            </div>

          </div>
        </th>

        <td mat-cell class="text-center bg-light-pink scenario-moderato-col" *matCellDef="let element">

          @if (element.ModerateScenario != null && element.ModerateScenario != '') {
          <img [src]="element.ModerateScenario" [height]="17" alt="Valore scenario moderato" />
          }
          @else { <span>-</span> }


        </td>


      </ng-container>

      <!-- Scenario favorevole Column -->
      <ng-container matColumnDef="ScenarioFavorevole">

        <th mat-header-cell class="text-center bg-light-pink scenario-moderato-col" *matHeaderCellDef>
          Scenario favorevole
        </th>

        <td mat-cell class="text-center bg-light-pink scenario-moderato-col" *matCellDef="let element">

          @if (element.FavorableScenario != null && element.FavorableScenario != '') {
          <img [src]="element.FavorableScenario" [height]="17" alt="Valore scenario favorevole" />
          }
          @else { <span>-</span> }


        </td>


      </ng-container>

      <!-- Scenario sfavorevole Column -->
      <ng-container matColumnDef="ScenarioSfavorevole">

        <th mat-header-cell class="text-center bg-light-pink scenario-moderato-col" *matHeaderCellDef>
          Scenario sfavorevole
        </th>

        <td mat-cell class="text-center bg-light-pink scenario-moderato-col" *matCellDef="let element">

          @if (element.UnfavourableScenario != null && element.UnfavourableScenario != '') {
          <img [src]="element.UnfavourableScenario" [height]="17" alt="Valore scenario sfavorevole" />
          }
          @else { <span>-</span> }


        </td>


      </ng-container>

      <!-- Scenario stress Column -->
      <ng-container matColumnDef="StressScenario">

        <th mat-header-cell class="text-center bg-light-pink scenario-moderato-col" *matHeaderCellDef>
          Scenario di stress
        </th>

        <td mat-cell class="text-center bg-light-pink scenario-moderato-col" *matCellDef="let element">

          @if (element.StressScenario != null && element.StressScenario != '') {
          <img [src]="element.StressScenario" [height]="17" alt="Valore scenario di stress" />
          }
          @else { <span>-</span> }


        </td>


      </ng-container>
      @if(RendAttesiView == 'nascondi'){

      }




      <!-- Infortuni Column -->
      <ng-container matColumnDef="IsInjury">
        <th mat-header-cell mat-sort-header class="text-center bg-light-blue" *matHeaderCellDef> Infortuni </th>
        <td mat-cell class="text-center" *matCellDef="let element">
          @if (element.IsInjury) {
          <i class="fa-solid fa-check check-icon"></i>
          }
          @else {
          <i class="fa-solid fa-xmark xmark-icon"></i>
          }
        </td>
      </ng-container>

      <!-- Conver. rendita Column -->
      <ng-container matColumnDef="IsConvertible">
        <th mat-header-cell mat-sort-header class="text-center bg-light-blue" *matHeaderCellDef> Conver. rendita </th>
        <td mat-cell class="text-center" *matCellDef="let element">
          @if (element.IsConvertible) {
          <i class="fa-solid fa-check check-icon"></i>
          }
          @else {
          <i class="fa-solid fa-xmark xmark-icon"></i>
          }
        </td>
      </ng-container>

      <!-- PRESTAZ. FIN. Columns -->

      <!-- Obiettivo investim. Column -->
      <ng-container matColumnDef="InvestTrgt">
        <th mat-header-cell mat-sort-header class="text-center bg-light-blue" *matHeaderCellDef> Obiettivo investim.
        </th>
        <td mat-cell class="text-center" *matCellDef="let element"> {{element.InvestTrgt}} </td>
      </ng-container>

      <!-- Grado rischio Column -->
      <ng-container matColumnDef="RiskGrade">
        <th mat-header-cell mat-sort-header class="text-center bg-light-blue" *matHeaderCellDef> Grado rischio </th>
        <td mat-cell class="text-center" *matCellDef="let element"> {{element.RiskGrade}} </td>
      </ng-container>

      <!-- Ann. gestione Column -->
      <!-- Per il momento non abbiamo il dato -->

      <!-- Stacco cedole Column -->
      <!-- Per il momento non abbiamo il dato -->


      <tr mat-header-row *matHeaderRowDef="getGroupHeaderCols()" class="tbl-group-header-row"></tr>
      <tr mat-header-row *matHeaderRowDef="columns" class="tbl-header-row"></tr>
      <tr mat-row *matRowDef="let row; let odd = odd; columns: columns;" class="tbl-body-row"></tr>
    </table>
  </div>
  <mat-paginator class="product-list-paginator" [pageSizeOptions]="[10, 25, 100]"></mat-paginator>

  <div class="save-button-container">
    <app-save-button [saveType]="resultsFrom"></app-save-button>
  </div>



  <app-product-list-faq></app-product-list-faq>



  <app-side-alert [isShowKeepAnswer]="false" [isShowEnableGuide]="false" [isViewQuestionInfo]="false"
    [isViewClickProductInfo]="true">
  </app-side-alert>



</div>